export default "__VITE_ASSET__B94_5EGH__"